import { z } from 'zod';

export const reframeClipRequestSchema = z.object({
  localPath: z.string(),
});

export type IReframeClipRequest = z.infer<typeof reframeClipRequestSchema>;
